/* 
Object:         Navigation Bar (this is only active in the mobile view)
Description:    Handlers the actions that are availible when the user clicks on one of the buttons in the navigation bar.
Used in:        Mobile View only
*/

import * as navigation from './navigation';

/**
 * Set event handlers for the navigation bar.
 */
export const initialize = function () {

    $("#gotoCurrentNode").on("click", function () {
        navigation.navigateToCurrentNode();
    });

    $("#gotoCurrentModule").on("click", function () {
        navigation.navigateToCurrentModule();
    });
}
